var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.globalCompanyPermission && _vm.globalUserPermission)?_c('div',{staticClass:"grid-cell"},[_c('router-link',{attrs:{"id":`gridNameEditor${_vm.data.id}`,"to":{name: 'TemplateDetailsSummary', query: {
      externalId: _vm.$route.query.externalId,
      clientId: _vm.$route.query.clientId,
      templateId: _vm.data.id,
      isSearchingTemplate: _vm.$route.query.isSearchingTemplate,
      isCreatingCampaign: _vm.$route.query.isCreatingCampaign,
      canCreateTemplate: _vm.$route.query.canCreateTemplate,
      userEmail: _vm.$route.query.userEmail} }}},[_c('span',{staticClass:"grid-cell--title"},[_vm._v(_vm._s(_vm.data.name))]),_c('br')])],1):_c('div',{staticClass:"grid-cell"},[_c('span',{staticClass:"grid-cell--title"},[_vm._v(_vm._s(_vm.data.name))]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }